export enum ELoaderActionEnum {
  SHOW = 'show',
  HIDE = 'hide'
}
